import { render } from "./IvyView.vue?vue&type=template&id=84e2e6b8"
import script from "./IvyView.vue?vue&type=script&lang=js"
export * from "./IvyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__